import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartLeftFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22 12c0-5.211-3.956-9.496-9.022-10v20C18.044 21.496 22 17.211 22 12ZM10.973 13.005V22C6.237 21.529 2.47 17.753 2 13.005h8.973ZM2 10.995C2.47 6.247 6.237 2.471 10.973 2v8.995H2Z" />
  </svg>
);
export default IconDrillingPartLeftFilledSizeM;
